// Pure, dependency-free duration predicate for story videos.
//
// Kept in its own module (not on StoriesCard) so it stays jest-testable
// without pulling in the axios-heavy card and its modal/query graph.
//
// Instagram Stories accept video segments between 3 and 60 seconds. A null /
// undefined duration (image story, or duration not yet extracted) is treated
// as valid — the guard only fires when a concrete out-of-range value exists.
export const isStoryDurationValid = (
  dur: number | null | undefined,
): boolean => dur == null || (dur >= 3 && dur <= 60);
